export default function FeatureSection() {
  return (
    <section className="px-6 md:px-10 lg:px-16 py-16 md:py-20 bg-background-50">
      <div className="text-center mb-12 md:mb-16">
        <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 font-semibold mb-3">
          Fresh Finds
        </h2>
        <p className="text-foreground-500 text-sm">
          Why thousands trust our spreadsheet hub
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        <div className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20modern%20desk%20setup%20with%20a%20sleek%20laptop%20open%20showing%20a%20colorful%20data%20dashboard%2C%20a%20ceramic%20coffee%20mug%20and%20small%20succulent%20plant%20nearby%2C%20light%20oak%20wooden%20desk%20surface%2C%20bright%20natural%20daylight%20from%20a%20window%2C%20contemporary%20workspace%20photography%2C%20fresh%20and%20inviting%20tones%20with%20warm%20wood%20and%20soft%20green%20accents&width=700&height=700&seq=feat-daily-v3&orientation=squarish"
            alt="Daily Updated Spreadsheets"
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
            <h3 className="text-background-50 font-heading text-xl md:text-2xl font-semibold mb-2">
              Daily Updated Spreadsheets
            </h3>
            <p className="text-background-50/80 text-sm">Fresh finds every 24 hours</p>
          </div>
        </div>

        <div className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20four%20shopping%20bags%20in%20different%20bold%20colors%20coral%20pink%20emerald%20green%20mustard%20yellow%20and%20navy%20blue%20standing%20on%20a%20light%20grey%20studio%20floor%2C%20soft%20diffused%20overhead%20lighting%2C%20editorial%20product%20photography%2C%20playful%20and%20modern%20composition%20with%20vibrant%20color%20contrast&width=700&height=700&seq=feat-agents-v3&orientation=squarish"
            alt="Multi-Agent Coverage"
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
            <h3 className="text-background-50 font-heading text-xl md:text-2xl font-semibold mb-2">
              Multi-Agent Coverage
            </h3>
            <p className="text-background-50/80 text-sm">CSSBuy, KakoBuy, Superbuy &amp; more</p>
          </div>
        </div>

        <div className="group relative rounded-xl overflow-hidden aspect-square cursor-pointer">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vintage%20brass%20magnifying%20glass%20resting%20on%20an%20open%20leather%20notebook%20on%20a%20dark%20walnut%20wood%20desk%2C%20warm%20golden%20desk%20lamp%20lighting%2C%20sophisticated%20editorial%20photography%2C%20rich%20dark%20brown%20and%20brass%20tones%2C%20intellectual%20and%20refined%20atmosphere%20with%20soft%20dramatic%20shadows&width=700&height=700&seq=feat-quality-v3&orientation=squarish"
            alt="Verified Quality Picks"
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-6">
            <h3 className="text-background-50 font-heading text-xl md:text-2xl font-semibold mb-2">
              Verified Quality Picks
            </h3>
            <p className="text-background-50/80 text-sm">Curated by spreadsheet experts</p>
          </div>
        </div>
      </div>
    </section>
  );
}